import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getAccountService = (request: t.GetAccountRequestType) => {
  log.info("getAccountService Request: " + JSON.stringify(request));
  let GET_ACCOUNT_API_ENDPOINT = `${apiCoreEndpoint}/account`;
  if (request.id) {
    GET_ACCOUNT_API_ENDPOINT += `/${request.id}`;
  } else if (request.params && request.params.name) {
    log.info("Filtering by Account Name: " + request.params.name);
    GET_ACCOUNT_API_ENDPOINT += `?name=${request.params.name}`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ACCOUNT_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ACCOUNT_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getAccountsService = (request?: t.GetAccountsRequestType) => {
  const GET_ACCOUNTS_API_ENDPOINT = `${apiCoreEndpoint}/account`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ACCOUNTS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ACCOUNTS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getCurrentUserAccountOwnerByAccountNameService = (
  request: t.GetCurrentUserAccountOwnerRequestType
) => {
  let GET_USER_OWNS_ACCOUNT_API_ENDPOINT = `${apiCoreEndpoint}/account/current-user/owner`;
  if (request.params) {
    log.info(
      `Requesting Current User's Ownership status of Account: ${request.params.account_name}`
    );
    GET_USER_OWNS_ACCOUNT_API_ENDPOINT += `?account=${request.params.account_name}`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_USER_OWNS_ACCOUNT_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(
        response,
        GET_USER_OWNS_ACCOUNT_API_ENDPOINT
      );
    })
    .then((json) => {
      return json;
    });
};

export const addAccountService = (request: t.CreateAccountRequestType) => {
  log.info("addAccountService Request: " + JSON.stringify(request));
  const GET_ACCOUNTS_API_ENDPOINT = `${apiCoreEndpoint}/account`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(GET_ACCOUNTS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ACCOUNTS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const modifyAccountService = (request: t.ModifyAccountRequestType) => {
  log.info("modifyAccountService Request: " + JSON.stringify(request));
  const accountId = request.id;
  const MODIFY_ACCOUNT_API_ENDPOINT = `${apiCoreEndpoint}/account/${accountId}`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_ACCOUNT_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_ACCOUNT_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteAccountService = (request: t.DeleteAccountRequestType) => {
  log.info("deleteAccountService Request: " + JSON.stringify(request));
  const accountId = request.id;
  const DELETE_ACCOUNT_API_ENDPOINT = `${apiCoreEndpoint}/account/${accountId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_ACCOUNT_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_ACCOUNT_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
